// TankView shared theme tokens. See TSP-142.
// Source of truth for colors, spacing, radii, breakpoints. New mini apps
// should import from here instead of redefining BRAND inline.

export const colors = {
  primary: "#1a472a",
  primaryLight: "#2d6a3e",
  accent: "#c8a951",
  text: "#1f2937",
  textSecondary: "#6b7280",
  textMuted: "#9ca3af",
  border: "#e5e7eb",
  cardBg: "#ffffff",
  pageBg: "#f3f4f6",
  error: "#dc2626",
  warning: "#d97706",
  success: "#059669",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
};

export const radii = {
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12,
  pill: 9999,
};

export const breakpoints = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
};

// Status palette for Needs Action and other dashboards.
export const statusColors = {
  Open: "#3b82f6",
  Scheduled: "#f59e0b",
  "In Process": "#059669",
  Stop: "#dc2626",
  Completed: "#7c3aed",
  Closed: "#4b5563",
};

// Multi-hue palette for charts that benefit from distinct hues.
export const barPalette = [
  "#1a472a", "#2563eb", "#0d9488", "#7c3aed", "#b45309",
  "#0369a1", "#be185d", "#4338ca", "#065f46", "#9333ea",
];

// Backwards-compat alias so callers migrating off `BRAND` can switch with a one-line change.
export const BRAND = colors;

const theme = { colors, spacing, radii, breakpoints, statusColors, barPalette };
export default theme;
